import { Search, VStack } from '@revolut-internal/ui-kit'

import { PermissionBoundary } from 'containers/PermissionBoundary'

import { useMessageSearch } from './useMessageSearch'

export const SupportTab = () => {
  const { onChange } = useMessageSearch()

  return (
    <VStack mt="s-16">
      <PermissionBoundary permissions={['debug.process_actions.view']}>
        <Search placeholder="Paste Rita client message ID to begin" onChange={onChange} />
      </PermissionBoundary>
    </VStack>
  )
}
